import { createActions } from 'redux-actions';

export const currencyActions = createActions({
    SET_ACTIVE_CURRENCY:  (code) => code,
    SET_DEFAULT_CURRENCY: () => void 0,
});
